import { render } from "./AppCreateFolderPopUp.vue?vue&type=template&id=6a7b6b74&scoped=true&ts=true"
import script from "./AppCreateFolderPopUp.vue?vue&type=script&lang=ts"
export * from "./AppCreateFolderPopUp.vue?vue&type=script&lang=ts"

import "./AppCreateFolderPopUp.vue?vue&type=style&index=0&id=6a7b6b74&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7b6b74"]])

export default __exports__